import {ProtocolActivityDetailsBySerialCodeDataWrapper} from '../wrappers/protocolActivityDetailsBySerialCodeDataWrapper';

export class ProtocolActivityDetailsBySerialCodeViewModel {
    position: number;
    protocolCode: string;
    accountCode: string;
    email: string;
    startTimeDetailedDate: number;
    title: string;
    exerciseType: string;
    duration: number;
    repetition: number;
    sensors: string;
    appVersion: string;
    downloadRawDataAction: string;
    activityCode: string;

    public static from(dataWrapper: ProtocolActivityDetailsBySerialCodeDataWrapper[]): ProtocolActivityDetailsBySerialCodeViewModel[] {
        const data = [];
        dataWrapper.forEach ((dataRow, i) => {
            const convertedData = new ProtocolActivityDetailsBySerialCodeViewModel();
            convertedData.position = i + 1;
            convertedData.protocolCode = dataRow.protocolCode;
            convertedData.accountCode = dataRow.accountCode;
            convertedData.email = dataRow.email;
            convertedData.startTimeDetailedDate = dataRow.startTime;
            convertedData.title = dataRow.title;
            convertedData.exerciseType = dataRow.exerciseType;
            convertedData.duration = dataRow.duration;
            convertedData.repetition = dataRow.repetition;
            convertedData.sensors = dataRow.sensors;
            convertedData.appVersion = dataRow.appVersion;
            convertedData.activityCode = dataRow.activityCode;
            convertedData.downloadRawDataAction = 'Download Csv';

            data.push(convertedData);
        });
        return data;
    }
}
